const CURRENT_VERSION = '2.1'
export default CURRENT_VERSION
